import { getQuickSortAnimation } from "../SortingVisualizer/QuickSortAlgorithm";
import classes from "../SortingVisualizer/SortingVisualizer.module.css";
function backtonormal() {
  const resetbtn = document.getElementById("reset_btn");
  const inputs = document.getElementById("inputs");
  const quicksort = document.getElementById("QuickSort");
  const mergesort = document.getElementById("MergeSort");
  const bubblesort = document.getElementById("BubbleSort");
  const insertionsort = document.getElementById("InsertionSort");
  quicksort.classList.remove(`${classes.selected}`);
  mergesort.classList.remove(`${classes.disable}`);
  bubblesort.classList.remove(`${classes.disable}`);
  insertionsort.classList.remove(`${classes.disable}`);
  inputs.classList.remove(`${classes.disable}`);
  resetbtn.classList.remove(`${classes.disable}`);
}
export default async function QuickSort({ array, speed }) {
  const PRIMARY_COLOR = "turquoise";

  const ANNIMATION_S = Math.floor(300 - 5 * speed);
  const annimations = getQuickSortAnimation(array);
  for (let i = 0; i < annimations.length; i++) {
    const arrayBars = document.getElementsByClassName("array-bar");
    const element = annimations[i];

    if (element[0] === "index") {
      const barOneIdx = element[1];
      const barTwoIdx = element[2];
      const height1 = element[3];
      const height2 = element[4];
      const barOneStyle = arrayBars[barOneIdx - 1].style;
      const barTwostyle = arrayBars[barTwoIdx - 1].style;

      setTimeout(() => {
        barOneStyle.backgroundColor = "green";
        barTwostyle.backgroundColor = "red";
        barOneStyle.height = `${height1}px`;
        barTwostyle.height = `${height2}px`;
        setTimeout(() => {
          barOneStyle.backgroundColor = PRIMARY_COLOR;
          barTwostyle.backgroundColor = PRIMARY_COLOR;
        }, Math.floor(ANNIMATION_S / 2));
      }, i * ANNIMATION_S);
    }
    if (element[0] === "pswapidx" || element[0] === "pivot") {
      if (element[0] === "pivot") {
        setTimeout(() => {
          const pivotidx = element[1];
          const barpivotStype = arrayBars[pivotidx - 1].style;
          barpivotStype.backgroundColor = "yellow";
          barpivotStype.innerHtml = "Swap";
        }, i * ANNIMATION_S);
      } else {
        const barOneIdx = element[1];
        const barTwoIdx = element[2];
        const height1 = element[3];
        const height2 = element[4];
        const barOneStyle = arrayBars[barOneIdx - 1].style;
        const barTwostyle = arrayBars[barTwoIdx - 1].style;
        setTimeout(() => {
          barOneStyle.backgroundColor = "yellow";
          barTwostyle.backgroundColor = "blue";
          barOneStyle.height = `${height1}px`;
          barTwostyle.height = `${height2}px`;
          setTimeout(() => {
            barOneStyle.backgroundColor = PRIMARY_COLOR;
            barTwostyle.backgroundColor = PRIMARY_COLOR;
          }, Math.floor(ANNIMATION_S / 2));
          if (i === annimations.length - 1) {
            backtonormal();
          }
        }, i * ANNIMATION_S);
      }
    }
  }
}
